import React from 'react';
import { ArrowRight, Database, PiggyBank, Users, FileCheck, RefreshCw, UserCog } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const Solutions = () => {
  const solutions = [
    {
      icon: Database,
      title: 'End to end Core MFI Solution on cloud',
      description: 'Explore our robust and modern end to end Core Microfinance solution available fully on cloud and subscribe using our flexible pricing models that allow us to grow together.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=800&fit=crop',
      link: '#core-mfi'
    },
    {
      icon: PiggyBank,
      title: 'Managing Deposits made easy',
      description: 'We provide a full coverage for your deposit accounts with automated saving tools, enabling you to provide micro-saving and goal based saving products.',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=800&fit=crop',
      link: '#deposits'
    },
    {
      icon: Users,
      title: 'Agency Banking',
      description: 'Go beyond your brick and mortar infrastructure with our Agency banking (tablet based) solution and enable the internal and external Agents to onboard and service your customers where they are.',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=800&fit=crop',
      link: '#agency'
    },
    {
      icon: FileCheck,
      title: 'Loan Origination and Credit Appraisal',
      description: 'Manage your loan applications and credit appraisal with ease using our automated Loan Origination solution that enables the end customers to initiate their applications on your website as well as on the agency banking apps and instant approvals.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=800&fit=crop',
      link: '#loan-origination'
    },
    {
      icon: RefreshCw,
      title: 'Reconciliation Software Solution',
      description: 'Advanced reconciliation platform that automates matching and validating financial transactions across multiple payment channels including NEFT, RTGS, IMPS, UPI, ATM and POS reconciliation. Built for accuracy, speed, and compliance.',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=800&fit=crop',
      link: '#reconciliation'
    },
    {
      icon: UserCog,
      title: 'HRMS',
      description: 'Empower your workforce with fintage HRMS — a fully integrated Human Capital platform purpose-built for banks, MFIs and NBFCs. From hiring to well-being, everything runs on one system: Talent Acquisition & Onboarding · Core HR & Self Service · Workforce Management · Payroll Excellence · Talent Management · Employee Productivity · Engagement & Well-being.',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=800&fit=crop',
      link: '#hrms'
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Our Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive financial technology solutions designed to transform your operations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <Card 
              key={index}
              className="group overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={solution.image} 
                  alt={solution.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center">
                    <solution.icon className="h-6 w-6 text-white" />
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  {solution.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {solution.description}
                </p>
                <Button 
                  variant="link" 
                  className="text-blue-600 hover:text-blue-700 p-0 group/btn"
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                >
                  Learn More
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;